import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Markdown from "markdown-to-jsx"
import theme from "styles/theme"

const colors = {
  oddBase: {
    iconColor: theme.midBlue,
    labelColor: theme.lightBlue,
    titleColor: theme.textGray,
    descriptionColor: theme.textGray,
    backgroundColor: theme.blue20,
  },
  oddHover: {
    iconColor: theme.white,
    labelColor: theme.white,
    titleColor: theme.white,
    descriptionColor: theme.white,
    backgroundColor: theme.midBlue,
  },
  evenBase: {
    iconColor: theme.orange,
    labelColor: theme.midOrange,
    titleColor: theme.textGray,
    descriptionColor: theme.textGray,
    backgroundColor: theme.lightYellow,
  },
  evenHover: {
    iconColor: theme.white,
    labelColor: theme.white,
    titleColor: theme.white,
    descriptionColor: theme.white,
    backgroundColor: theme.orange,
  },
}

const crossLinkStyle = (base, hover) => {
  return {
    transition: "background-color 250ms",
    backgroundColor: base.backgroundColor,
    ".label": {
      color: base.labelColor,
      transition: "color 250ms, opacity 250ms",
    },
    ".title": { color: base.titleColor, transition: "color 250ms" },
    ".icon *": {
      stroke: `${base.iconColor} !important`,
      transition: "stroke 250ms",
    },

    ":hover": {
      backgroundColor: hover.backgroundColor,
      ".label": {
        color: hover.labelColor,
        opacity: 0.7,
      },
      ".title": { color: hover.titleColor },
      ".icon *": { stroke: `${hover.iconColor} !important` },
    },
  }
}

export const CrossLinkItem = ({ icon, label, title, link }) => (
  <Link
    to={link}
    className="crossLink"
    css={{
      display: "grid",
      gridTemplateColumns: "70px 1fr",
      alignItems: "center",
      gap: 42,
      padding: 56,
      ...crossLinkStyle(colors.evenBase, colors.evenHover),
      ":nth-of-type(4n+1), :nth-of-type(4n+4)": crossLinkStyle(colors.oddBase, colors.oddHover),
      [theme.tablet]: {
        padding: "45px 36px",
        gridTemplateColumns: "50px 1fr",
        alignItems: "start",
        gap: 24,
      },
      [theme.mobile]: {
        padding: "45px 30px",
        gridTemplateColumns: "40px 1fr",
        ":nth-of-type(odd)": crossLinkStyle(colors.oddBase, colors.oddHover),
        ":nth-of-type(even)": crossLinkStyle(colors.evenBase, colors.evenHover),
      },
    }}
  >
    <Markdown className="icon">{icon.asset.svg.content}</Markdown>

    <div>
      <div
        className="label"
        css={{
          ...theme.t5sm,
          marginBottom: 9,
          [theme.mobile]: { marginBottom: 5 },
        }}
      >
        {label}
      </div>
      <div className="title" css={theme.t4}>
        {title}
      </div>
    </div>
  </Link>
)

const CrossLinks = ({ id, links }) => {
  return (
    <div
      id={id}
      css={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gridGap: 10,
        padding: 10,
        backroungColor: theme.white,
        [theme.mobile]: {
          gridTemplateColumns: "1fr",
        },
      }}
    >
      {links.map((link, index) => (
        <CrossLinkItem key={`crosslinkitem${index}`} {...link} />
      ))}
    </div>
  )
}

export default CrossLinks

CrossLinkItem.propTypes = {
  icon: PropTypes.shape({
    asset: PropTypes.shape({
      svg: PropTypes.shape({
        content: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
}

CrossLinks.propTypes = {
  id: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape(CrossLinkItem.propTypes)),
}
